import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import scrollTo from 'simple-scrollTo';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import resourceSubject from 'next/javascripts/reactivity/resource-subject';
import { closest } from 'next/javascripts/modules/dom';

import 'next/stylesheets/components/todo-page/element';

Component('tr-todo-page', {
  mixins: [eventListenerMixin],

  properties: {
    todoId: String,
    todoGuid: String,
    projectGuid: String,
  },

  connected() {
    this.header = this.querySelector('tr-todo-page-header');
    this.main = this.querySelector('tr-todo-page-main');

    this.listenTo(this, {
      'tr-todo-page-header:run': this.handleEvent.bind(this),
      'tr-todo-page-header:pause': this.handleEvent.bind(this),
      'tr-todo-page-main:complete': this.handleEvent.bind(this),
      'tr-todo-page-main:reopen': this.handleEvent.bind(this),
      'tr-todo-page-main:assigneeChange': this.handleEvent.bind(this),
      'tr-todo-page-main:dateChange': this.handleEvent.bind(this),
      'tr-todo-page-main:priorityChange': this.handleEvent.bind(this),
      'tr-todo-page-todo-title:titleChange': this.handleEvent.bind(this),
      'tr-todo-attachments:attachmentsChange': this.handleEvent.bind(this),
      'tr-todo-page-labels:labelsChange': this.handleEvent.bind(this),
      'tr-todo-page-fields:fieldChange': this.handleEvent.bind(this),
      'tr-grid-subtodo-row:update': this.handleSubtodoEvent.bind(this),
      'tr-grid-subtodo-row:completed': this.handleSubtodoEvent.bind(this),
      'tr-grid-subtodo-row:running': this.handleSubtodoEvent.bind(this),
    });

    this.subscription = resourceSubject('todo').subscribe({
      next: this.syncTodoStatus.bind(this),
    });

    if (window.location.hash) this.scrollTo();
  },

  syncTodoStatus(event, todo) {
    if (todo.guid !== this.todoGuid) return;
    const page = closest(this, '.tr-page') || document.querySelector('.page-inner');

    if (event === 'destroy') {
      if (page.classList.contains('tr-page')) {
        const parentTaskLink = Array.from(page.querySelectorAll('.breadcrumb-link')).pop();
        if (parentTaskLink) {
          parentTaskLink.click();
        } else {
          page.close();
        }
      } else if (page && page.id === 'page-todo') {
        const url = page.dataset.parentUrl;
        window.tower.stack.load(url, {
          root: true,
          replace: true,
        });
      }
    }
  },

  handleEvent(event) {
    event.stopPropagation();
    const method = this[event.type.split(':')[1]];
    if (method) method.call(this, event);
  },

  handleSubtodoEvent(e) {
    e.stopPropagation();
    const type = e.type.split(':')[1];
    const rowData = {};
    switch (type) {
      case 'update':
        [rowData.start_date, rowData.end_date] = e.detail.params.due_date.split(',');
        resourceSubject('todo').next('update', {
          guid: e.detail.guid, rowData,
        });
        break;
      case 'completed':
      case 'running':
        resourceSubject('todo').next('update', {
          guid: e.detail.guid,
        });
        break;
      default:
        break;
    }
  },

  run() {
    this.main.classList.add('running');
    this.main.assignToCurrentMember();
    resourceSubject('todo').next('update', {
      id: this.todoId,
      guid: this.todoGuid,
      rowData: { running: true },
    });
  },

  pause() {
    this.main.classList.remove('running');
    resourceSubject('todo').next('update', {
      id: this.todoId,
      guid: this.todoGuid,
      rowData: { running: false },
    });
  },

  complete() {
    this.header.classList.add('completed');
    this.header.classList.remove('running');
  },

  reopen() {
    this.header.classList.remove('completed');
  },

  assigneeChange(event) {
    const { todo } = event.detail;
    this.pause();
    resourceSubject('todo').next('update', {
      id: todo.id,
      guid: todo.guid,
      updateOnCalendar: true,
      rowData: {
        assignee: todo.tableViewData.assignee,
        todo: todo.tableViewData.todoForCalendar,
      },
    });
  },

  dateChange(event) {
    const { todo } = event.detail;
    resourceSubject('todo').next('update', {
      id: todo.id,
      guid: todo.guid,
      updateOnCalendar: true,
      rowData: {
        start_date: todo.tableViewData.start_date,
        due_date: todo.tableViewData.due_date,
        todo: todo.tableViewData.todoForCalendar,
      },
    });
  },

  priorityChange(event) {
    const { todo } = event.detail;
    resourceSubject('todo').next('update', {
      id: todo.id,
      guid: todo.guid,
      updateOnCalendar: true,
      rowData: {
        priority: todo.tableViewData.priority,
        todo: todo.tableViewData.todoForCalendar,
      },
    });
  },

  titleChange(event) {
    const { todo } = event.detail;
    resourceSubject('todo').next('update', {
      id: todo.id,
      guid: todo.guid,
      updateOnCalendar: true,
      rowData: {
        title: todo.tableViewData.title,
        todo: todo.tableViewData.todoForCalendar,
      },
    });
  },

  attachmentsChange({ target }) {
    const attachments = target.querySelectorAll('.todo-attachment');
    target.querySelector('.download-all').classList.toggle('hide', attachments.length < 2);
  },

  labelsChange(event) {
    const { todo } = event.detail;
    resourceSubject('todo').next('update', {
      id: todo.id,
      guid: todo.guid,
      rowData: { labels: todo.tableViewData.labels },
    });
  },

  fieldChange(event) {
    const { todo, fieldKey } = event.detail;
    resourceSubject('todo').next('update', {
      id: todo.id,
      guid: todo.guid,
      updateOnCalendar: true,
      rowData: {
        [fieldKey]: todo.tableViewData[fieldKey],
        todo: todo.tableViewData.todoForCalendar,
      },
    });
  },

  scrollTo() {
    const target = this.querySelector(window.location.hash);
    if (!target) return;
    let container = closest(this, '.page__content');
    if (!container) container = 'body, html';

    scrollTo({
      target: $(target),
      container: $(container),
      animation: false,
      offset: { y: 84, x: 0 },
    });
  },

  disconnected() {
    this.stopListening();
  },
});
